


















































































import { Component, Vue, Prop } from 'vue-property-decorator'
import GlassType from '@/data/glass-type'
import GlassOption from '@/data/glass-option'
import GlassOptionValue from '@/data/glass-option-value'
import { ModuleOption } from '@/data/enums'
import '@/icons/present'
@Component({})
export default class GlassTypeTile extends Vue {
  @Prop({ default: 0 }) private index!: number
  @Prop() private item!: GlassType
  @Prop({ default: true }) private show!: boolean
  // private showPrice: boolean = true
  private isMulti: boolean = true
  private directory: string = 'multi/'

  private get dneyeSelected (): boolean {
    return this.$store.state.cart.currentItem.dneye
  }

  private get showPrice (): boolean {
    return this.$store.state.data.optician.showPrices
  }

  private get glassImageType (): string {
    return this.$store.state.data.optician.glassImageType.toString()
  }

  private get displayPrice (): number {
    let price = this.item.glassesPrice
    this.item.options.forEach((option: GlassOption) => {
      if (option.optionId !== ModuleOption.Suncolor && option.optionId !== ModuleOption.Dneye) {
        const selectedValue = option.values.find((optionValue: GlassOptionValue) => optionValue.selected)
        option.values.forEach((optionValue: GlassOptionValue) => {
          if (!selectedValue) {
            if (optionValue.isDefault) {
              price += optionValue.price
            }
          } else {
            if (optionValue.selected) {
              price += optionValue.price
            }
          }
        })
      }
    })
    return price
  }

  private get image (): string {
    const currentItem = this.$store.state.cart.currentItem
    let glassType
    if (currentItem.type) {
      if (currentItem.glasses.isMulti) {
        glassType = 'multi'
      } else if (currentItem.glasses.isSingle) {
        glassType = 'single'
      } else if (currentItem.glasses.screenGlasses) {
        glassType = 'screen'
      }
      glassType += (currentItem.glasses.sunglasses) ? 'sun' : ''
    }

    let getImage
    try {
      getImage = require('@/assets/images/glasses/' +
      this.glassImageType + '/' +
      glassType + '/glassquality_' +
      (this.index + 1) + '.png')
    } catch (e) {
      getImage = ''
    }

    return getImage
  }
}
